import apolloClient from 'api/apolloClient';
import { apiFetch } from 'api/apiFetch';
import { GET_ORG_AFFILIATION } from 'api/queries/aaaService';
import { FullAgency, SetUserOrfAffiliationParams } from 'types/aaaService';
import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export async function getOrgAffiliation(): Promise<FullAgency[]> {
  return (
    await apolloClient.query<{ getOrgAffiliationV2: FullAgency[] }>({
      query: GET_ORG_AFFILIATION,
      fetchPolicy: 'no-cache',
    })
  ).data.getOrgAffiliationV2;
}

export const setUserOrgAffiliation = async (params: SetUserOrfAffiliationParams): Promise<string> => {
  const res = await apiFetch(`https://${COMMON_URLS.api}/aaa/Prod/setUserOrgAffiliation`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(params),
  });
  return res.text();
};
